import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Message } from '../../model/message/message.model';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MessageType } from '../../model/message/message-type';
import { DefaultNotySettings } from './noty.config';
import { DnNotyComponent } from '../../components/noty-components/dn-noty/dn-noty.component';

@Injectable({
  providedIn: 'root',
})
export class NotyService {
  snackBarOpen: boolean;
  constructor(private readonly snack: MatSnackBar) {}

  /**
   * An Observable from type Subject. Gets invoked when "postMessage" is used.
   * @returns Object from type "Message"
   * * */
  messageAdded = new Subject<Message>();
  private readonly messages: Message[] = [];

  /**
   * Post a new message, responsible for storing the message and inform all the components subscribing to this change
   * @param message {Message}
   * @param data
   * @param timeout
   * * */
  postMessage(message: Message, data: any = {}, timeout?: number): any {
    if (this.snackBarOpen) {
      return;
    }

    this.snackBarOpen = true;
    this.snack
      .openFromComponent(DnNotyComponent, {
        ...this.buildNotyConfig(timeout),
        data: {
          bodyText: message.content,
          icon: message.type === MessageType.ERROR ? 'alert-noty-icon' : 'success-noty-icon',
          containerClass: message.type === MessageType.ERROR ? 'error' : 'success',
          ...data,
        },
      })
      .afterDismissed()
      .subscribe(() => (this.snackBarOpen = false));
  }

  private buildNotyConfig(timeout?: number): MatSnackBarConfig {
    const config: MatSnackBarConfig = { ...DefaultNotySettings };
    if (timeout && timeout > 0) {
      config.duration = timeout;
    }

    return config;
  }
}
